import React from 'react'
import { useParams } from 'react-router'

import Error from '@Components/VAC/exception'

const bbsProps = {
  error: {
    title: '페이지를 찾을 수 없습니다.',
    description: '삭제되었거나 없는 게시글입니다',
    button: '우리집 바로가기',
    handleClick: () => {
      window.location.href = '/myhouse'
    },
  },
}

const defaultProps = {
  error: {
    title: '페이지를 찾을 수 없습니다.',
    description: '현재는 확인할 수 없는 정보입니다.',
    button: '우리집 바로가기',
    handleClick: () => {
      window.location.href = '/myhouse'
    },
  },
}

interface params {
  deniedCategory: string
  deniedType: string
}

function DeniedPage() {
  const params = useParams<params>()

  if (!params.deniedCategory) {
    return <Error {...defaultProps} />
  }

  if (params.deniedCategory === 'bbs') {
    return <Error {...bbsProps} />
  }

  return <Error {...defaultProps} />
}
export default DeniedPage
